import { render, staticRenderFns } from "./NewPortfolioAction.vue?vue&type=template&id=79c1163e&scoped=true&"
import script from "./NewPortfolioAction.vue?vue&type=script&lang=ts&"
export * from "./NewPortfolioAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c1163e",
  null
  
)

export default component.exports